// extracted by mini-css-extract-plugin
export default {"getOrExistParentContainer":"style_getOrExistParentContainer__BvtAQ","title":"style_title__WfWUZ","body":"style_body__pVGjd","footer":"style_footer__v9JmA"};